<template>
  <svg
    :class="['icon', size]"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30.14 16.66"
  >
    <path
      class="cls-1"
      d="M29.67,13.93L16.2.47s0,0,0,0c-.13-.13-.27-.22-.42-.29-.39-.19-.84-.22-1.25-.08-.22.08-.42.2-.59.37L.47,13.93c-.62.62-.62,1.64,0,2.26.31.31.72.47,1.13.47s.82-.16,1.13-.47L15.07,3.86l12.34,12.34c.31.31.72.47,1.13.47s.82-.16,1.13-.47c.62-.62.62-1.64,0-2.26Z"
    />
  </svg>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    size: {
      type: String,
      default: 'size'
    }
  }
})
</script>

<style lang="scss" scoped>
.icon {
  fill: currentColor;
  stroke-width: 0;
}
.size {
  width: 1em;
  height: 1em;
}
.lg {
  width: 1.25em;
  height: 1.25em;
}
.sm {
  width: 0.85em;
  height: 0.85em;
}
</style>
